import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const WhyPlayPage = () => {
  useEffect(() => {
    document.title = 'Why Play Baseball ? | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    const cssFiles = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css', 
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    cssFiles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    };

    const initializeMenu = async () => {
      try {
        await loadScript('/js/jquery.min.js');
        await loadScript('/js/jquery.slimmenu.js');
        
        setTimeout(() => {
          if (window.$ && typeof window.$.fn.slimmenu === 'function') {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            });
          }
        }, 300);
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    initializeMenu();

    return () => {
      if (window.$ && window.$('ul.slimmenu').length > 0) {
        try {
          window.$('ul.slimmenu').off();
        } catch (e) {}
      }
    };
  }, []);

  return (
    <div id="outer_m">
      {/* Header */}
      <header>
        <div id="zero">
          <img className="logo" src="/logo.png" alt="SportsTMS Logo" />
        </div>
        <div id="one">
          <div id="two">Sports Tournament Management System</div>
          <div id="three">THE OFFICIAL SITE OF INDIAN BASEBALL</div>
        </div>
        <img className="" src="/second_logo.png" alt="Secondary Logo" />
      </header>

      {/* Navigation */}
      <nav>
        <ul className="slimmenu">
          <li>
            <Link to="/">
              <span className="glyphicon glyphicon-home" style={{fontSize: '15px'}}></span>
            </Link>
          </li>
          <li>
            <a href="#">About</a>
            <ul>
              <li><a href="/history">History</a></li>
              <li><a href="/pdf/Amateur_Baseball_federation.zip">Constitution</a></li>
              <li><a href="/international-recognition">International Recognition</a></li>
              <li><a href="/registration">Registration</a></li>
              <li><Link to="/affiliates">Affiliates</Link></li>
              <li><Link to="/bearer">Executive Committee</Link></li>
            </ul>
          </li>
          <li>
            <a href="#">Rules</a>
            <ul>
              <li>
                <a href="#">Basics</a>
                <ul>
                  <li><Link to="/score-keeping">Keeping Score</Link></li>
                  <li><Link to="/baseball-lingo">Baseball Lingo</Link></li>
                  <li><Link to="/abbreviation">Abbreviation</Link></li>
                  <li><Link to="/stats">Stats 101</Link></li>
                </ul>
              </li>
              <li><Link to="/rules">Baseball Rules</Link></li>
              <li>
                <a href="#">Play Baseball</a>
                <ul>
                  <li><Link to="/skills">4 Skills of Baseball</Link></li>
                  <li><Link to="/batting-order">Batting Order</Link></li>
                  <li><Link to="/fielding-position">Fielding Position</Link></li>
                  <li><Link to="/why-play">Why Play Baseball</Link></li>
                  <li><a href="/pdf/manual.pdf" target="_blank">Manual</a></li>
                </ul>
              </li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manual</a></li>
            </ul>
          </li>
          <li><a href="/events">Events</a></li>
          <li>
            <a href="#">Schedule</a>
            <ul>
              <li><a href="/forthcoming-events">Forthcoming Events</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Participants</a>
            <ul>
              <li><a href="/admin-login">User Login</a></li>
              <li><a href="#">Roster</a></li>
              <li><a href="/certificate-verify">Certificates</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Information</a>
            <ul>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/website-info">Website information</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Downloads</a>
            <ul>
              <li><a href="/pdf/Roster_form.pdf" target="_blank">Roster form</a></li>
              <li><a href="/pdf/team_Roster.pdf" target="_blank">Team roster</a></li>
              <li><a href="/pdf/Score_Sheet.pdf" target="_blank">Score sheet</a></li>
            </ul>
          </li>
          <li><a href="/photo-gallery">Gallery</a></li>
          <li><a href="/contact">Contact Us</a></li>
        </ul>
      </nav>

      {/* Main Content */}
      <div id="main">
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
        </div>

        <a href="/about"><div id="stick_right"></div></a>

        <div id="basic">
          <div id="keep3">
            <h3 className="heading3">Why Play Baseball ?</h3>
            <p className="depart_p">
              Baseball helps you grow up - both in mind and body. It brings you new friends, shows you how to get along with others, and helps you live up to your Cub Scout ideals - the Cub scout Promise and the Law of the Pack.<br /><br />

              If you find you like baseball a lot, you may want to join a youth league or try out for your school team. When you are ready for college, you may be able to get a baseball scholarship. Some may gain added experience while playing for the State/Indian Team which represents the country in international competition and in the Olympics. And for some, the goal may even be to play professional ball someday.<br /><br />

              But whether you play baseball just for fun or go for a career in the big leagues, remember that the best you can do is to do your best.<br /><br />

              The Merit certificate of participation in Sub Junior / Junior / Senior, national championship will help you to get admission for higher studies in your respective states.<br /><br />

              In International participation certificate will be eligible for Form I<br />

              In National participation certificate will be eligible for Form II<br />

              If you want to know more about any specific youth leagues or details about baseball itself, contact the Amateur Baseball Federation of India at the address below.<br />

              The Amateur Baseball Federation of India (ABFI) is the national governing body for International Baseball Association, Baseball Federation of Asia. The ABFI represents the interests of all amateur baseball players and associations on the Indian Olympic committee and the International Association of Amateur Baseball (AINBA) They are responsible for the selection, training, and fielding of the Indian team for international competition annually. Including the world championships, the pan American games, and the Olympic games. The ABFI protects the rights and statues of amateur baseball players and provides services unique and necessary to all fans and players.<br />

              You may contact the Amateur Baseball Federation by writing or calling.<br /><br />

              <label className="bol">Amateur Baseball Federation of India, </label><br />
              B-IV/317B, Keshav Puram, Delhi-110035, India.<br />
              Telefax : +91-11-27169327.<br /><br />

              <label className="bol">HINTS IN TEACHING PROCEDURES FOR DEN COACHES</label><br />

              Some boys will already know quite a bit about playing baseball. Others will think they do. Few will admit they don't. So plan to explain and to demonstrate each rule and technique to everyone, regardless of what they may already know. Check each body individually as you take up new skills and practice the old ones.<br />

              You can conduct practices in a gym, a vacant lot, on a lawn, a park, a driveway or parking lot, or wherever the ground in level and clear. Consider asking.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div id="outer_main">
          <div id="outer1">
            <div id="aku11">
              <h4 className="link_heading">LOCATION</h4>
              <h4 className="ft">B4/317B, Keshav Puram,<br />Delhi - 110035</h4>
            </div>
            <div id="aku22">
              <h4 className="link_heading">AROUND THE WEB</h4>
              <div id="social">
                <div id="contact_a_dn">
                  <div className="sl sl2"><i className="fa fa-facebook-f" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl3"><i className="fa fa-youtube-play" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl4"><i className="fa fa-twitter" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl5"><i className="fa fa-linkedin" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                </div>
              </div>
            </div>
            <div id="aku33">
              <h4 className="link_heading">CONTACT US</h4>
              <label className="ft">Phone : +918890029024, +919165276531<br />Email: abfi.secretarygeneral@gmail.com</label>
            </div>
          </div>
        </div>
        <div id="main_link">
          <div id="main_link_inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/rules">Rules</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/schedule">Schedule</a></li>
              <li><a href="/affiliates">Affiliates</a></li>
              <li><a href="/photo-gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
            <ul>
              <li><a href="/international-recognition">International & Recognition</a></li>
              <li><a href="/international-recognition-bfa">International & Recognition BFA</a></li>
              <li><a href="/pdf/voting_rights.pdf" target="_blank">Voting Rights</a></li>
              <li><a href="/registration">Certificate of Registration</a></li>
              <li><a href="/international-participation">International Participation</a></li>
              <li><a href="/pdf/ABFI_constitution.pdf">Constitution</a></li>
              <li><a href="/affiliates">Affiliated Units</a></li>
              <li><a href="#">Firm Name</a></li>
              <li><a href="#">Media Coverage</a></li>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manuals</a></li>
              <li><a href="/history">History</a></li>
              <li><a href="/bearer">Executive Committee</a></li>
              <li><a href="/website-info">Website Info</a></li>
            </ul>
            <div className="text-center">
              <hr />
              <p style={{color: '#fff'}}>For best results use Mozilla or Chrome browsers</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WhyPlayPage;